import { TRevenuesWeekly } from '../../api/APITypes';

export const MOCK_REVENUES_WEEKLY: TRevenuesWeekly = [
  {
    week: '2020 W-26',
    start_date: '2020-06-21',
    end_date: '2020-06-27',
    invoices_count: 7,
    total_margin: 17517.29,
    total_revenue: 148271.76,
  },
  {
    week: '2020 W-10',
    start_date: '2020-03-01',
    end_date: '2020-03-07',
    invoices_count: 3,
    total_margin: 3932.6600000000008,
    total_revenue: 34228.31,
  },
  {
    week: '2020 W-20',
    start_date: '2020-05-10',
    end_date: '2020-05-16',
    invoices_count: 8,
    total_margin: 25314.190000000002,
    total_revenue: 173180,
  },
  {
    week: '2020 W-44',
    start_date: '2020-10-25',
    end_date: '2020-10-31',
    invoices_count: 7,
    total_margin: 16971.07,
    total_revenue: 108501.52999999998,
  },
  {
    week: '2020 W-29',
    start_date: '2020-07-12',
    end_date: '2020-07-18',
    invoices_count: 5,
    total_margin: 10356.53,
    total_revenue: 83162.34,
  },
  {
    week: '2020 W-39',
    start_date: '2020-09-20',
    end_date: '2020-09-26',
    invoices_count: 10,
    total_margin: 19995.43,
    total_revenue: 151580.01,
  },
  {
    week: '2020 W-24',
    start_date: '2020-06-07',
    end_date: '2020-06-13',
    invoices_count: 4,
    total_margin: 8289.539999999999,
    total_revenue: 52435.03,
  },
  {
    week: '2020 W-38',
    start_date: '2020-09-13',
    end_date: '2020-09-19',
    invoices_count: 5,
    total_margin: 10636.509999999998,
    total_revenue: 77387.24,
  },
  {
    week: '2020 W-51',
    start_date: '2020-12-13',
    end_date: '2020-12-19',
    invoices_count: 7,
    total_margin: 23147.03,
    total_revenue: 195433.83999999997,
  },
  {
    week: '2020 W-31',
    start_date: '2020-07-26',
    end_date: '2020-08-01',
    invoices_count: 5,
    total_margin: 17915.4,
    total_revenue: 124412.46,
  },
  {
    week: '2020 W-19',
    start_date: '2020-05-03',
    end_date: '2020-05-09',
    invoices_count: 6,
    total_margin: 17337.68,
    total_revenue: 126749.67,
  },
  {
    week: '2020 W-42',
    start_date: '2020-10-11',
    end_date: '2020-10-17',
    invoices_count: 1,
    total_margin: 3826.81,
    total_revenue: 22662.39,
  },
  {
    week: '2020 W-22',
    start_date: '2020-05-24',
    end_date: '2020-05-30',
    invoices_count: 4,
    total_margin: 9507.5,
    total_revenue: 66456.92,
  },
  {
    week: '2020 W-50',
    start_date: '2020-12-06',
    end_date: '2020-12-12',
    invoices_count: 11,
    total_margin: 26937.63,
    total_revenue: 199077.05,
  },
  {
    week: '2020 W-46',
    start_date: '2020-11-08',
    end_date: '2020-11-14',
    invoices_count: 4,
    total_margin: 9088.9,
    total_revenue: 92368.81,
  },
  {
    week: '2020 W-06',
    start_date: '2020-02-02',
    end_date: '2020-02-08',
    invoices_count: 6,
    total_margin: 14027.679999999998,
    total_revenue: 121459.15000000001,
  },
  {
    week: '2020 W-01',
    start_date: '2019-12-29',
    end_date: '2020-01-04',
    invoices_count: 6,
    total_margin: 16265.71,
    total_revenue: 124069.01000000001,
  },
  {
    week: '2020 W-33',
    start_date: '2020-08-09',
    end_date: '2020-08-15',
    invoices_count: 5,
    total_margin: 10684.539999999999,
    total_revenue: 89723.59,
  },
  {
    week: '2020 W-48',
    start_date: '2020-11-22',
    end_date: '2020-11-28',
    invoices_count: 5,
    total_margin: 16579.39,
    total_revenue: 128225.88,
  },
  {
    week: '2020 W-41',
    start_date: '2020-10-04',
    end_date: '2020-10-10',
    invoices_count: 4,
    total_margin: 8702.740000000002,
    total_revenue: 70869.22,
  },
  {
    week: '2020 W-15',
    start_date: '2020-04-05',
    end_date: '2020-04-11',
    invoices_count: 4,
    total_margin: 7509.67,
    total_revenue: 53811.45999999999,
  },
  {
    week: '2020 W-34',
    start_date: '2020-08-16',
    end_date: '2020-08-22',
    invoices_count: 6,
    total_margin: 14403.810000000003,
    total_revenue: 115542.56999999999,
  },
  {
    week: '2020 W-04',
    start_date: '2020-01-19',
    end_date: '2020-01-25',
    invoices_count: 9,
    total_margin: 11687.07,
    total_revenue: 95204.7,
  },
  {
    week: '2020 W-03',
    start_date: '2020-01-12',
    end_date: '2020-01-18',
    invoices_count: 5,
    total_margin: 19032.58,
    total_revenue: 128640.80000000002,
  },
  {
    week: '2020 W-27',
    start_date: '2020-06-28',
    end_date: '2020-07-04',
    invoices_count: 4,
    total_margin: 13983.49,
    total_revenue: 98332.48999999999,
  },
  {
    week: '2020 W-09',
    start_date: '2020-02-23',
    end_date: '2020-02-29',
    invoices_count: 4,
    total_margin: 10817.73,
    total_revenue: 77878.44,
  },
  {
    week: '2020 W-25',
    start_date: '2020-06-14',
    end_date: '2020-06-20',
    invoices_count: 2,
    total_margin: 4578.22,
    total_revenue: 39981.28,
  },
  {
    week: '2020 W-49',
    start_date: '2020-11-29',
    end_date: '2020-12-05',
    invoices_count: 2,
    total_margin: 2490.9199999999996,
    total_revenue: 18050.75,
  },
  {
    week: '2020 W-52',
    start_date: '2020-12-20',
    end_date: '2020-12-26',
    invoices_count: 7,
    total_margin: 19202.649999999998,
    total_revenue: 148975.91,
  },
  {
    week: '2020 W-17',
    start_date: '2020-04-19',
    end_date: '2020-04-25',
    invoices_count: 6,
    total_margin: 11109.44,
    total_revenue: 84798.03000000001,
  },
  {
    week: '2020 W-08',
    start_date: '2020-02-16',
    end_date: '2020-02-22',
    invoices_count: 1,
    total_margin: 3220.92,
    total_revenue: 32762.930000000004,
  },
  {
    week: '2020 W-36',
    start_date: '2020-08-30',
    end_date: '2020-09-05',
    invoices_count: 1,
    total_margin: 743.0100000000001,
    total_revenue: 9182.6,
  },
  {
    week: '2020 W-13',
    start_date: '2020-03-22',
    end_date: '2020-03-28',
    invoices_count: 6,
    total_margin: 11638.919999999998,
    total_revenue: 74266.73000000001,
  },
  {
    week: '2020 W-28',
    start_date: '2020-07-05',
    end_date: '2020-07-11',
    invoices_count: 8,
    total_margin: 17074.93,
    total_revenue: 128448.75,
  },
  {
    week: '2020 W-02',
    start_date: '2020-01-05',
    end_date: '2020-01-11',
    invoices_count: 5,
    total_margin: 15306.82,
    total_revenue: 110204.57,
  },
  {
    week: '2020 W-35',
    start_date: '2020-08-23',
    end_date: '2020-08-29',
    invoices_count: 5,
    total_margin: 14606.859999999999,
    total_revenue: 117923.02999999998,
  },
  {
    week: '2020 W-32',
    start_date: '2020-08-02',
    end_date: '2020-08-08',
    invoices_count: 4,
    total_margin: 12143.83,
    total_revenue: 98934.20999999999,
  },
  {
    week: '2020 W-18',
    start_date: '2020-04-26',
    end_date: '2020-05-02',
    invoices_count: 2,
    total_margin: 4907.710000000001,
    total_revenue: 40919.81,
  },
  {
    week: '2020 W-45',
    start_date: '2020-11-01',
    end_date: '2020-11-07',
    invoices_count: 4,
    total_margin: 7927.509999999999,
    total_revenue: 49909.13,
  },
  {
    week: '2020 W-37',
    start_date: '2020-09-06',
    end_date: '2020-09-12',
    invoices_count: 4,
    total_margin: 7704.2,
    total_revenue: 66050.46,
  },
  {
    week: '2020 W-16',
    start_date: '2020-04-12',
    end_date: '2020-04-18',
    invoices_count: 6,
    total_margin: 16231.24,
    total_revenue: 117589.76000000001,
  },
  {
    week: '2020 W-12',
    start_date: '2020-03-15',
    end_date: '2020-03-21',
    invoices_count: 8,
    total_margin: 21675.989999999998,
    total_revenue: 164804.45999999996,
  },
  {
    week: '2020 W-14',
    start_date: '2020-03-29',
    end_date: '2020-04-04',
    invoices_count: 6,
    total_margin: 12264.210000000003,
    total_revenue: 93109.85999999999,
  },
  {
    week: '2020 W-11',
    start_date: '2020-03-08',
    end_date: '2020-03-14',
    invoices_count: 3,
    total_margin: 7521.43,
    total_revenue: 54153.270000000004,
  },
  {
    week: '2020 W-05',
    start_date: '2020-01-26',
    end_date: '2020-02-01',
    invoices_count: 4,
    total_margin: 9925.93,
    total_revenue: 66166.56999999999,
  },
  {
    week: '2020 W-40',
    start_date: '2020-09-27',
    end_date: '2020-10-03',
    invoices_count: 5,
    total_margin: 11463.89,
    total_revenue: 94434.01,
  },
  {
    week: '2020 W-21',
    start_date: '2020-05-17',
    end_date: '2020-05-23',
    invoices_count: 6,
    total_margin: 13297.16,
    total_revenue: 112484.41999999998,
  },
  {
    week: '2020 W-07',
    start_date: '2020-02-09',
    end_date: '2020-02-15',
    invoices_count: 3,
    total_margin: 7966.639999999999,
    total_revenue: 63191.979999999996,
  },
  {
    week: '2020 W-43',
    start_date: '2020-10-18',
    end_date: '2020-10-24',
    invoices_count: 2,
    total_margin: 6142.120000000001,
    total_revenue: 55365.73,
  },
  {
    week: '2020 W-30',
    start_date: '2020-07-19',
    end_date: '2020-07-25',
    invoices_count: 4,
    total_margin: 7311.09,
    total_revenue: 52253.86,
  },
];
